export const _getMyProfileData = (state, action) => action.payload;
